import { Column } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16339 — a free tag for media items (what an item is: "logo",
 * "certification", "website"). Names are unique among live tags, enforced in
 * the service: a unique index would block re-using a deleted tag's name.
 */
@Entity('media_tag')
export class MediaTagEntity extends BaseEntity {
	@Column({
		type: 'varchar',
		name: 'name',
		length: 80,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public name!: string;
}
